import { useMemo } from 'react';
import { AppModuleId } from '../types';
import { appModuleRegistry } from '../utils/appRegistry';

const useAppRegistry = (placedModuleIds: AppModuleId[] = []) => {
  const placedSet = useMemo(() => new Set<AppModuleId>(placedModuleIds), [placedModuleIds]);

  return useMemo(() => {
    const registryById = Object.fromEntries(appModuleRegistry.map((module) => [module.id, module]));
    const activeModules = appModuleRegistry.filter((module) => module.status === 'active');
    const placedModules = activeModules.filter((module) => placedSet.has(module.id));
    const availableModules = activeModules.filter((module) => !placedSet.has(module.id));

    return {
      registry: appModuleRegistry,
      registryById,
      activeModules,
      availableModules,
      placedModules,
      backlogModules: appModuleRegistry.filter((module) => module.status === 'backlog'),
      legacyModules: appModuleRegistry.filter((module) => module.status === 'legacy'),
    };
  }, [placedSet]);
};

export default useAppRegistry;
